import React from 'react'

import useStyles from './styles'

const MarkdownLink = ({ node, children, ...props }) => {
  const classes = useStyles()

  return (
    <a {...props} className={classes.root}>
      {children}
    </a>
  )
}

export default MarkdownLink
